export default __webpack_public_path__ + "locales/lv/SendInviteDialog.json?hash=ec092b68c42fa35d11efc3b38bddaffb";